/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "okTZb6GkU0U",
    thumbnail: "https://i.ytimg.com/vi/okTZb6GkU0U/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCh7hsAOQ-ZDrxVoY7ObhdAA969bw",
    title: "HORIZON ZERO DAWN Walkthrough Gameplay Part 1 - Aloy (PS4 Pro)",
    creatorAvatar: "https://yt3.ggpht.com/ytc/AKedOLTBSwIyFAMOXI0XdsyxQ8NAEI93NI2-UUTA2qM-oQ=s88-c-k-c0x00ffffff-no-rj",
    creator: "theRadBrad",
    duration: "44:20",
    views: "5.7M",
    category: "Walkthrough",
    description: "Horizon Zero Dawn Walkthrough Gameplay Part 1 includes a Review and the Horizon Zero Dawn Story Intro and Main Mission 1: A Gift from the Past for PS4 Pro. Horizon Zero Dawn Gameplay Walkthrough will include Episode 1, EP 1, Reaction, Review, Story, Aloy, Skills, Crafting, Main Quests, Side Quests, All Missions, Cut Scenes, Cinematics and more until the Ending of the Story Campaign. Thank you Sony for Horizon Zero Dawn!",
  },
  {
    _id: "Z9_Tb_TcPYI",
    thumbnail: "https://i.ytimg.com/vi/Z9_Tb_TcPYI/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDk7GI7-JmSUxtSzhdOb7O98PlE-w",
    title: "So I ranked ALL the AC games...",  
    creatorAvatar: "https://yt3.ggpht.com/ytc/AMLnZu9p2PSQYppxkM2V32y5E5tfKxkrWVsUMHn-szcN1g=s88-c-k-c0x00ffffff-no-rj",
    creator: "jayvee",
    duration: "28:39",
    views: "2.0M",
    category: "Adventure",
    description: "So I ranked ALL the AC games... and there's gonna be some tears 😅.",
  },
  {
    _id: "QEepWwi7xJs",
    thumbnail: "https://i.ytimg.com/vi/QEepWwi7xJs/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDFZ_EP_mK_RY_hyYVBWMu91YD02A",
    title: "The Last of Us Review - A Look Back At One of The Greatest Games Ever Made",
    creatorAvatar: "https://yt3.ggpht.com/ytc/AKedOLQ7iPx8nEEY9NilxC36-QJII26DJaJdO1dbrVy_=s68-c-k-c0x00ffffff-no-rj",
    creator: "GamingBolt",
    duration: "8:47",
    views: "44K",
    category: "Action",
    description: "Back in June 2013, we reviewed The Last of Us. Now seven years later, with the sequel's release closing, we have decided to re-run our review. So, without further delay, let's get started.",
  },
  {
    _id: "v1xAWm9wOR8",
    thumbnail: "https://i.ytimg.com/vi/v1xAWm9wOR8/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDD5CZ743YNEJtnk4eD5CyGgHwfEQ",
    title: "Horizon Zero Dawn: The Story So Far",
    creatorAvatar: "https://yt3.ggpht.com/ytc/AKedOLT9vOaMO54OxmEuWFok6SGdru2OZ5VLIT5YirBb=s68-c-k-c0x00ffffff-no-rj",
    creator: "IGN Games",
    duration: "19:30",
    views: "219K",
    category: "Adventure",
    description: "With Horizon Forbidden West out on Feb. 18 for PS4 and PS5, Aloy begins a new journey into parts of the world she's never explored in hopes of finding answers and solutions to save humanity.",
  },
  {
    _id: "M7ABdDSYJko",
    thumbnail: "https://i.ytimg.com/vi/M7ABdDSYJko/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLACU8bXp889SK2Yu4QK538iYeHtqQ",
    title: "How Edith Finch Handles Death",
    creatorAvatar: "https://yt3.ggpht.com/ytc/AKedOLQkMNCTvBxClSaQ-d8n4Lt3f-sk8_LWGfxEwzn01w=s68-c-k-c0x00ffffff-no-rj",
    creator: "Jacob Geller",
    duration: "9:10",
    views: "149K",
    category: "Horror",
    description: "What Remains of Edith Finch is a game about death. That is not unusual. So why does it feel so different?",
  },
  {
    _id: "6agHaPAjJSY",
    thumbnail: "https://i.ytimg.com/vi/6agHaPAjJSY/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLB5x54x2CecyXBybZtFbSZZCKwJAw",
    title: "Spider-Man: Miles Morales - 8 Amazing Easter Eggs, Secrets, and References",
    creatorAvatar: "https://yt3.ggpht.com/H_---ano_f27DOCejDhUdBMtBcxcv32MoXmFKQc_mBcxYSH4HPZTGuBUdm7UgI5VlutMOVX2=s88-c-k-c0x00ffffff-no-rj",
    creator: "IGN",
    duration: "5:30",
    views: "88K",
    category: "Action",
    description: "Much like in Spider-Man 2018 for PlayStation 4, Miles Morales follows a similar formula of being chock-full of Easter eggs and secrets for players to find and enjoy. For this list, we'll be focusing on some of the more hidden bits that players would either have to go out of their way to find, or could miss altogether without deep knowledge of Spider-Man's lore. Enjoy!",
  },
  {
    _id: "GwLvCvTXORw",
    thumbnail: "https://i.ytimg.com/vi/GwLvCvTXORw/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCxrludM739h-XQSplnuScZcw57jw",
    title: "GOD OF WAR Full Movie (2021) 4K ULTRA HD Action",
    creatorAvatar: "https://yt3.ggpht.com/ytc/AKedOLSBCPdJI4hN0waVn0WaO0T5x_Wy9HeGBxel77qkPQ=s88-c-k-c0x00ffffff-no-rj",
    creator: "GameClips",
    duration: "2:53:43",
    views: "8.9M",
    category: "Action",
    description: "GOD OF WAR Full Movie (2021) 4K ULTRA HD Action. New Trailers 2021!",
  },
  {
    _id: "mJ1KCTsi1QM",
    thumbnail: "https://i.ytimg.com/vi/mJ1KCTsi1QM/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAvorJ-ZPj4y3AW0prB4uOvgpxlJA",
    title: "The Witcher 3: The ULTIMATE Beginners Guide (2021)",
    creatorAvatar: "https://yt3.ggpht.com/ytc/AKedOLQ7dXDAvBTpej-5t1NtcYHciI-UZO73E4_Pbh1hqg=s68-c-k-c0x00ffffff-no-rj",
    creator: "MasterAssassin",
    duration: "8:51",
    views: "705K",
    category: "Adventure",
    description: "Welcome and I hope this Witcher 3 Beginners guide is able to help you out. The Witcher 3 was a very confusing and challenging game for me when I first started. It takes hours of to get used to and comfortable with the game so I made this video to make your learning curve much quicker so you can get to enjoying this amazing game.",
  },
  {
    _id: "kxOWURAIMIw",
    thumbnail: "https://i.ytimg.com/vi/kxOWURAIMIw/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLB_RxWShqzvvTlt7vWZkQAUOfS_dw",
    title: "How To - The Sims 3 - Get Rich The Legitimate Way",
    creatorAvatar: "https://yt3.ggpht.com/ytc/AKedOLQNzIAIY-gnuyK73UtXJwZbkeJvA_-zk5YdSG1r=s88-c-k-c0x00ffffff-no-rj",
    creator: "Jellyfishsoda",
    duration: "10:43",
    views: "117K",
    category: "Simulation",
    description: "A video tutorial/how-to that teaches you how to generate massive amounts of simoleans without cheating, all the money is legitimate and I will show you how in this video.  All additional information is listed here in the comments.  By the end of this video my character is making 30,000+ recurring Simoleans a week, which can be increased further by just playing a little longer.",
  },
  {
    _id: "veLQ2cdyBBo",
    thumbnail: "https://i.ytimg.com/vi/veLQ2cdyBBo/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCUxq-LaxpY-C2Q-HrvvyuhXCeNFA",
    title: "Horizon Forbidden West Review",
    creatorAvatar: "https://yt3.ggpht.com/H_---ano_f27DOCejDhUdBMtBcxcv32MoXmFKQc_mBcxYSH4HPZTGuBUdm7UgI5VlutMOVX2=s68-c-k-c0x00ffffff-no-rj",
    creator: "IGN",
    duration: "14:38",
    views: "1.6M",
    category: "Adventure",
    description: "Horizon Forbidden West reviewed on PlayStation 5 by Simon Cardy. A triumphant combination of enthralling combat, top-tier creature and character design, and a captivating open world, Horizon Forbidden West is an absolute blast and fantastic showcase for the power of the PS5.",
  },
  {
    _id: "UOheOYV-H2U",
    thumbnail: "https://i.ytimg.com/vi/UOheOYV-H2U/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDeJtAE0kiHrCzi0oa9HseBCjJVhw",
    title: "GHOST OF TSUSHIMA Gameplay Walkthrough Part 1",
    creatorAvatar: "https://yt3.ggpht.com/ytc/AKedOLTQZMTAVEmPPXsSb8FSac1w3-ai339vMhvJ5bOnUw=s88-c-k-c0x00ffffff-no-rj",
    creator: "MKIceAndFire",
    duration: "28:11:26",
    views: "1.6M",
    category: "Walkthrough",
    description: "Ghost Of Tsushima Walkthrough Part 1 and until the last part will include the full Ghost Of Tsushima Gameplay on PS4 Pro. This Ghost Of Tsushima Gameplay is recorded in 1080p HD on PS4 Pro and will include the full game, all endings and all boss fights. Enjoy!",
  },
  {
    _id: "lqKhLzwi_pM",
    thumbnail: "https://i.ytimg.com/vi/lqKhLzwi_pM/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAhYl-Vah5jLsdX1FDz8hzfT6MmGw",
    title: "Elden Ring - Part 1 - THEY SAID THIS GAME IS PERFECT",
    creatorAvatar: "https://yt3.ggpht.com/ZaLZ8BNqB0KOLIqkA87YHlr0O5T7mQOO9puALuOYdpSVoMDkGLT2H-3S_enYzCFkH2vMT5GS=s88-c-k-c0x00ffffff-no-rj",
    creator: "Hollow",
    duration: "1:07:53",
    views: "1.1M",
    category: "Walkthrough",
    description: "Elden Ring Gameplay Walkthrough Part 1 FULL GAME. Welcome to the official series of the Elden Ring story. This series will include the Elden Ring full game's story plot, all character upgrades, all ability unlocks, all boss fights, all missions, review and first impressions.",
  },
  {
    _id: "phbn-NfCWxw",
    thumbnail: "https://i.ytimg.com/vi/phbn-NfCWxw/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDequOdF8I_LLvq6fsjzGCLe4S_pQ",
    title: "I CAN TIME TRAVEL! (Life Is Strange - Episode 1 FULL Gameplay)",
    creatorAvatar: "https://yt3.ggpht.com/5oUY3tashyxfqsjO5SGhjT4dus8FkN9CsAHwXWISFrdPYii1FudD4ICtLfuCw6-THJsJbgoY=s88-c-k-c0x00ffffff-no-rj",
    creator: "PewDiePie",
    duration: "1:35:12",
    views: "13M",
    category: "Simulation",
    description: "Walcome to full playthrough gameplay lets play, let's play, luts ploh or whatever else I can type to get better search hits of Life Is Strange! I thought it was pretty damn good so...If you ever feel like pausing and checking it out yourself, I recommend it",
  },
  {
    _id: "GqzH7k75t2M",
    thumbnail: "https://i.ytimg.com/vi/GqzH7k75t2M/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAqW_ow48pXJ4bo96is82kvO1QicQ",
    title: "Amnesia: Rebirth - Official Gameplay Trailer",
    creatorAvatar: "https://yt3.ggpht.com/H_---ano_f27DOCejDhUdBMtBcxcv32MoXmFKQc_mBcxYSH4HPZTGuBUdm7UgI5VlutMOVX2=s68-c-k-c0x00ffffff-no-rj",
    creator: "IGN",
    duration: "4:59",
    views: "394K",
    category: "Horror",
    description: "Gaze upon five minutes of deadly puzzle-solving gameplay from Amnesia: Rebirth, the next chapter in Frictional Games survival horror series.",
  },
  
];
